
      import PenEditDash from './pen-edit-dash.vue'
      import type { App, Plugin } from 'vue'

      export const PenEditDashPlugin: Plugin = {
        install(app: App) {
          app.component('PenEditDash', PenEditDash)
        },
      }
      export { PenEditDash }
      